<template>

    <card>
        <card-header>
            <card-title>
                <translate>abgeschlossene Bestellungen</translate>
            </card-title>
        </card-header>
        <card-content>
            <table class="table table--stripped">
                <thead>
                <tr>
                    <th>
                        <translate>PF-Nr</translate>
                    </th>
                    <th>
                        <translate>Projekttitel</translate>
                    </th>
                    <th class="text-center">
                        <translate>Zeichnung</translate>
                    </th>
                    <th class="text-right">
                        <translate>Stück</translate>
                    </th>
                    <th class="text-right">
                        <translate>Nettopreis</translate>
                    </th>
                    <th class="text-right">
                        <translate>Liefertermin</translate>
                    </th>
                    <th class="text-center">
                        <translate>Fortschritt<span>Produzent</span></translate>
                    </th>
                    <th class="text-right">
                        <translate>Bestelldatum</translate>
                    </th>
                    <th class="text-center">
                        <translate>Status <span>Partfactory</span></translate>
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="order in completedOrdersTable" :key="order.index">
                    <td>
                        <Link :href="this.$$route('component', {'askForQuote':order.id})">{{ order.pfnumber }}</Link>
                    </td>
                    <td>{{ order.project_name }}</td>
                    <td class="text-center">
                        <file-download :sketch-file="order.client_sketch_file" v-if="order.client_sketch_file"/>
                        <file-download :cad-file="order.client_cad_file" v-if="order.client_cad_file"/>
                    </td>
                    <td class="text-right">{{ order.lot_qty }}</td>
                    <td class="text-right">{{ order.net_price }}</td>
                    <td class="text-right">{{ order.delivery_date }}</td>
                    <td class="text-center">
                        <production-progress-icons :producer-status="order.producer_order.producer_status"/>
                    </td>
                    <td class="text-right">{{ order.created_at }}</td>
                    <td class="text-center">
                        <translate>{{ order.status_string }}</translate>
                    </td>
                </tr>
                <tr v-if="noOrders">
                    <td colspan="10" class="text-center">
                        <strong>
                            <translate>keine Einträge vorhanden</translate>
                        </strong>
                    </td>
                </tr>
                </tbody>
            </table>
        </card-content>
    </card>
</template>

<script>
import Card from '@partfactory/Shared/Card/Card';
import CardContent from '@partfactory/Shared/Card/CardContent';
import CardTitle from '@partfactory/Shared/Card/CardTitle';
import CardHeader from '@partfactory/Shared/Card/CardHeader';
import FileDownload from '@partfactory/Shared/Elements/FileDownload';
import ProductionProgressIcons from '@partfactory/Shared/Elements/ProductionProgressIcons';

export default {
    name: 'DashboardCompletedOrders',
    components: {ProductionProgressIcons, FileDownload, CardHeader, CardTitle, CardContent, Card},
    props: {
        completedOrders: Object,
    },
    computed: {
        noOrders() {
            return this.completedOrders.length === 0;
        },
        completedOrdersTable() {
            let orders = Array;

            return Object.keys(this.completedOrders).map(key => {
                orders[key] = this.completedOrders[key];

                orders[key].lot_qty = orders[key].client_order.client_offer.amount;

                orders[key].net_price = this.$currency(orders[key].client_order.client_offer.net_price);

                orders[key].created_at = this.$date(orders[key].client_order.created_at);

                orders[key].delivery_date = this.$date(orders[key].client_order.delivery_at);

                orders[key].status_string = this.$readableStatusClient(orders[key].status);

                return orders[key];
            });
        },
    },
};
</script>
